module.exports = __webpack_public_path__ + "static/media/2_5.f833670c.png";